export const normalizeControlRoomBaseUrl = baseUrl => baseUrl?.trim() || '';

export const normalizeControlRoomPhoneNumber = phoneNumber =>
  phoneNumber?.trim() || '';

export const hasControlRoomBaseUrl = baseUrl =>
  Boolean(normalizeControlRoomBaseUrl(baseUrl));

export const hasControlRoomPhoneNumber = phoneNumber =>
  Boolean(normalizeControlRoomPhoneNumber(phoneNumber));

export const buildControlRoomLookupUrl = ({ baseUrl, phoneNumber }) => {
  const normalizedBaseUrl = normalizeControlRoomBaseUrl(baseUrl);
  const normalizedPhoneNumber = normalizeControlRoomPhoneNumber(phoneNumber);

  if (!normalizedBaseUrl || !normalizedPhoneNumber) {
    return '#';
  }

  const sanitizedBaseUrl = normalizedBaseUrl.replace(/\/+$/, '');
  return `${sanitizedBaseUrl}/caregivers/lookup?phone=${encodeURIComponent(normalizedPhoneNumber)}`;
};
